import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const DEFAULT_READ_INTERVAL_SECS = 15;

@Component({
  selector: 'app-barometer',
  templateUrl: './barometer.component.html',
  styleUrls: ['./barometer.component.scss']
})
export class BarometerComponent implements OnInit, OnDestroy {

  @Input() baroPort = 8002;
  @Input() readIntervalSecs = DEFAULT_READ_INTERVAL_SECS;

  mBarReading: number;
  lastBaroReadingTime: Date;
  lastPrometheusPollTime: Date;
  pastDueWaitMs = 500;
  logActive = false;
  pastDueSubject = new BehaviorSubject<boolean>(false);
  intervalId: any;

  constructor() { }

  async ngOnInit(): Promise<void> {
    await this.refresh();
    this.intervalId = setInterval(async () => {
      await this.refresh();
    }, this.readIntervalSecs * 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  async refresh(): Promise<void> {
    const prometheusUrl = `http://localhost:${this.baroPort}/metrics`;
  
    const pastDueTimeout = setTimeout(() => {
      this.pastDueSubject.next(true);
    }, this.pastDueWaitMs);
  
    try {
      const response = await fetch(prometheusUrl);
      const data = await response.text();
      //console.log('Prometheus data:', data);
      clearTimeout(pastDueTimeout);
  
      const baroLogActiveMatch = data.match(/baro_log_active\s+(\d+)/);
      const mBarReadingMatch = data.match(/baro_mbar\s+([\d.]+)/);
      const readIntervalSecsMatch = data.match(/baro_read_interval_secs\s+([\d.]+)/);
      const baroTimestampMatch = data.match(/baro_read_timestamp\s+(\d+)/);
  
      if (mBarReadingMatch && baroTimestampMatch) {
        this.mBarReading = parseFloat(mBarReadingMatch[1]);
        this.lastBaroReadingTime = new Date(parseInt(baroTimestampMatch[1], 10));
      } else {
        this.mBarReading = null;
        //this.lastBaroReadingTime = null;
      }
  
      if (baroLogActiveMatch) {
        this.logActive = baroLogActiveMatch[1] === '1';
      }

      // Calculate past due based on readIntervalSecsMatch and lastBaroReadingTime
      if (!readIntervalSecsMatch){
        this.pastDueSubject.next(true);
      } else if( baroTimestampMatch) {
        const readIntervalSecs = parseFloat(readIntervalSecsMatch[1]);
        const currentTime = new Date().getTime();
        const lastReadingTime = parseInt(baroTimestampMatch[1], 10);

        if (currentTime - lastReadingTime > readIntervalSecs * 1000) {
          this.pastDueSubject.next(true);
        } else {
          this.pastDueSubject.next(false);
        }
      } else {
        this.pastDueSubject.next(false);
      }

      this.lastPrometheusPollTime = new Date();
  
    } catch (error) {
      this.logActive = undefined;
      this.mBarReading = undefined;
      console.log('Error connecting to Prometheus endpoint at', prometheusUrl, error);      
      this.pastDueSubject.next(true);
    }
  }
}
